// extracted by mini-css-extract-plugin
module.exports = {"grid":"_2Jqd0v","label":"_1fpa5l","free":"_1tmHxG","clickable":"_3grtgv","link":"_3KeaKg"};